<template>
  <div class="content">
    <h2 class="page-title mb-1">取引申込フォーム</h2>
    <form class="section-wrapper" @submit.prevent="save">
      <validation-observer ref="observer" method="post">
        <company-base-info
          :is-get-data="isCompanyInfoGetData"
          :observer="observer"
          @setData="onSetBaseInfoData"
        />
        <section class="apply-tanto">
          <table class="table">
            <tr>
              <th>
                ご担当者名
                <span class="must">必須</span>
              </th>
              <td>
                <div class="row col-md-11">
                  <div class="row col-md-6 pr-md-0">
                    <div class="col-md-1">
                      <label class="mt-2">姓</label>
                    </div>
                    <div class="col-md-10">
                      <validation-provider
                        name="TANTO_MEI_SEI"
                        v-slot="{ errors }"
                        rules="required|max:20|char"
                      >
                        <b-form-input
                          v-model="form.TANTO_MEI_SEI"
                          ref="TANTO_MEI_SEI"
                          maxlength="20"
                          :state="errors.length ? false : null"
                          placeholder="山田"
                          trim
                          @blur="
                            form.TANTO_MEI_SEI = replaceChar(form.TANTO_MEI_SEI)
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row col-md-6 pr-md-0">
                    <div class="col-md-1">
                      <label class="mt-2">名</label>
                    </div>
                    <div class="col-md-10">
                      <validation-provider
                        name="TANTO_MEI"
                        v-slot="{ errors }"
                        rules="required|max:20|char"
                      >
                        <b-form-input
                          v-model="form.TANTO_MEI"
                          ref="TANTO_MEI"
                          maxlength="20"
                          :state="errors.length ? false : null"
                          placeholder="太郎"
                          trim
                          @blur="form.TANTO_MEI = replaceChar(form.TANTO_MEI)"
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                ご担当者メールアドレス
                <br v-if="isTablet" />
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="TANTO_MAIL_ADDR"
                  v-slot="{ errors }"
                  rules="required|max:50|email"
                >
                  <b-form-input
                    v-model="form.TANTO_MAIL_ADDR"
                    ref="TANTO_MAIL_ADDR"
                    class="col-md-6"
                    maxlength="50"
                    :state="errors.length ? false : null"
                    placeholder="yamada@mail.co.jp"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>ご担当者携帯番号</th>
              <td>
                <validation-provider
                  name="TANTO_TEL"
                  v-slot="{ errors }"
                  rules="tel"
                >
                  <b-form-input
                    class="col-md-6"
                    ref="TANTO_TEL"
                    maxlength="17"
                    v-model="form.TANTO_TEL"
                    :state="errors.length ? false : null"
                    placeholder="090-1234-5678"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
          </table>
        </section>

        <section class="mt-3 apply-company-detail">
          <table class="table">
            <tr>
              <th>
                定休日
                <span class="must">必須</span>
              </th>
              <td>
                <div class="pt-2">
                  <validation-provider v-slot="{ errors }" name="TEIKYU_BI">
                    <b-form-group>
                      <b-form-checkbox-group
                        v-model="form.TEIKYU_BI"
                        ref="TEIKYU_BI"
                        :options="teikyuList"
                      />
                    </b-form-group>
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                営業時間
                <span class="must">必須</span>
              </th>
              <td>
                <div class="row">
                  <div class="col-5 col-md-3 col-lg-2 pr-lg-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="EIGYO_JIKAN_START"
                      rules="required"
                    >
                      <b-form-select
                        v-model="form.EIGYO_JIKAN_START"
                        ref="EIGYO_JIKAN_START"
                        :state="errors.length ? false : null"
                        :options="eigyoJikanList"
                        trim
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <span class="py-smー2 col-1 col-lg-1 px-0 pt-2 pl-2 pl-lg-4">
                    〜
                  </span>
                  <div class="col-5 col-md-3 col-lg-2 pl-lg-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="EIGYO_JIKAN_END"
                      rules="required"
                    >
                      <b-form-select
                        v-model="form.EIGYO_JIKAN_END"
                        ref="EIGYO_JIKAN_END"
                        :state="errors.length ? false : null"
                        :options="eigyoJikanList"
                        trim
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                設立年月日
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="SETURITU_NENGETU"
                  v-slot="{ errors }"
                  rules="required|date"
                >
                  <DatePicker
                    ref="SETURITU_NENGETU"
                    clearable
                    :class="['px-0 col-md-4', { 'border-red': errors.length }]"
                    placeholder="2019/01/01"
                    v-model="seturituNengetu"
                  />
                  <div
                    v-if="errors.length"
                    class="invalid-feedback"
                    style="display: block"
                  >
                    <span class="border-red">{{ errors[0] }}</span>
                  </div>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                資本金
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="SHIHON_KIN"
                  v-slot="{ errors }"
                  rules="required|max:20|char"
                >
                  <b-form-input
                    v-model="form.SHIHON_KIN"
                    ref="SHIHON_KIN"
                    class="col-md-6"
                    maxlength="20"
                    :state="errors.length ? false : null"
                    placeholder="300万円"
                    trim
                    @blur="form.SHIHON_KIN = replaceChar(form.SHIHON_KIN)"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                月間取扱台数
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  name="GEKKAN_TORIATUKAI_DAISU"
                  rules="required"
                >
                  <b-form-select
                    v-model="form.GEKKAN_TORIATUKAI_DAISU"
                    ref="GEKKAN_TORIATUKAI_DAISU"
                    class="col-md-4"
                    :state="errors.length ? false : null"
                    :options="daisuList"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                月間輸送依頼台数
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  name="GEKKAN_YUSO_IRAI_DAISU"
                  rules="required"
                >
                  <b-form-select
                    v-model="form.GEKKAN_YUSO_IRAI_DAISU"
                    ref="GEKKAN_YUSO_IRAI_DAISU"
                    class="col-md-4"
                    :state="errors.length ? false : null"
                    :options="daisuList"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                月間登録輸送台数
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  name="GEKKAN_TOROKU_YUSO_DAISU"
                  rules="required"
                >
                  <b-form-select
                    v-model="form.GEKKAN_TOROKU_YUSO_DAISU"
                    ref="GEKKAN_TOROKU_YUSO_DAISU"
                    class="col-md-4"
                    :state="errors.length ? false : null"
                    :options="daisuList"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                現在ご利用の輸送会社
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="RIYO_YUSO_KAISYA_MEI"
                  v-slot="{ errors }"
                  rules="required|max:30|char"
                >
                  <b-form-input
                    v-model="form.RIYO_YUSO_KAISYA_MEI"
                    ref="RIYO_YUSO_KAISYA_MEI"
                    class="col-md-6"
                    maxlength="30"
                    :state="errors.length ? false : null"
                    placeholder="株式会社ロジコ"
                    trim
                    @blur="
                      form.RIYO_YUSO_KAISYA_MEI = replaceChar(
                        form.RIYO_YUSO_KAISYA_MEI
                      )
                    "
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th ref="TANTO_KAKUNIN_FILE">
                ご本人確認書類
                <span class="must">必須</span>
              </th>
              <td>
                <vue-dropzone
                  ref="myVueDropzone"
                  id="dropzone"
                  :class="[{ 'border-red': $v.form.TANTO_KAKUNIN_FILE.$error }]"
                  :options="dropzoneOptions"
                  @vdropzone-processing="vfileSend"
                  @vdropzone-success="vfilesent"
                  @vdropzone-file-added="Survey"
                  @vdropzone-removed-file="removeFile"
                />
                <div
                  v-if="$v.form.TANTO_KAKUNIN_FILE.$error"
                  class="err-message col-md-6"
                >
                  <p v-if="!$v.form.TANTO_KAKUNIN_FILE.required">
                    入力必須です
                  </p>
                </div>
                <div class="mt-3 mr-3">
                  <p class="f-size-20 ml-sm-3 mb-2">
                    本人確認書類(写真付き)1点または2点
                  </p>
                  <ul>
                    <li>自動車運転免許証(表面と裏面の2点をご提出ください)</li>
                    <li>
                      自動車運転経歴証明書(表面と裏面の2点をご提出ください)
                    </li>
                    <li>
                      パスポート(顔写真のあるページと住所が記載されているページの2点をご提出ください)
                    </li>
                    <li>
                      写真付き住民基本台帳カード(表面と裏面の2点をご提出ください)
                    </li>
                    <li>在留カード(表面と裏面の2点をご提出ください)</li>
                    <li>特別永住者証明書(表面と裏面の2点をご提出ください)</li>
                    <li>マイナンバーカード(表面のみご提出ください)</li>
                  </ul>
                  <p class="ml-3 red">
                    ※書類は全て、.jpg .bmp .gif
                    .pdf等のデジタルデータ(写真・スキャン)に変換しアップロードしてください。
                  </p>
                </div>
              </td>
            </tr>
          </table>
        </section>

        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">銀行口座情報</h4>
        <bank
          :is-get-data="isGinkoGetData"
          :observer="observer"
          @setData="onSetGinko"
        />

        <seikyu
          class="mt-5"
          :is-get-data="isSeikyuGetData"
          :observer="observer"
          @setData="onSetSeikyu"
        />

        <section class="mt-5 p-2 p-sm-3 mx-2" id="apply-consent">
          <div class="text-left underline ml-lg-5">
            <span>
              取引の申し込みにあたり、弊社「
              <a
                href="https://www.logi-co.co.jp/service/rules.pdf"
                target="_blank"
              >
                輸送規約
              </a>
              」「
              <a
                href="https://www.logi-co.co.jp/pdf/personalInfo.pdf"
                target="_blank"
              >
                個人情報取扱いについて
              </a>
              」のご確認、ご同意が必要となります。
            </span>
            <br />
            <span>
              以下の内容をご確認のうえ、ご同意いただける場合はチェックボックスにチェックを入れお申し込みください。
            </span>
          </div>
          <div class="my-3 my-md-5">
            <div class="mt-3 check-box-wrapper">
              <label class="col-md-4 pt-2 bold pc-fs-20">
                輸送規約・免責事項
              </label>
              <md-checkbox
                :class="[
                  'form-check-input md-primary col-md-3',
                  { 'border-red': $v.consent1.$error },
                  { 'pos-relative': isMS },
                ]"
                v-model="consent1"
                :value="true"
              >
                <strong>同意する</strong>
              </md-checkbox>
            </div>
            <div class="row">
              <label class="col-md-5" />
              <div
                v-if="$v.consent1.$error"
                class="err-message ml-5 col-md-5 mt-n2"
              >
                <p v-if="!$v.consent1.required">
                  確認後、チェックをお願いします
                </p>
              </div>
            </div>

            <div class="mt-1 check-box-wrapper">
              <label class="col-md-4 pt-2 bold pc-fs-20">
                個人情報の取り扱い
              </label>
              <md-checkbox
                :class="[
                  'form-check-input md-primary col-md-3',
                  { 'border-red': $v.consent2.$error },
                  { 'pos-relative': isMS },
                ]"
                v-model="consent2"
                :value="true"
              >
                <strong>同意する</strong>
              </md-checkbox>
            </div>
            <div class="row">
              <label class="col-md-5" />
              <div
                v-if="$v.consent2.$error"
                class="err-message ml-5 col-md-5 mt-n2"
              >
                <p v-if="!$v.consent2.required">
                  確認後、チェックをお願いします
                </p>
              </div>
            </div>
          </div>
          <div class="mt-4 ml-lg-5">
            <h5 class="bold pc-fs-20 ml-2">ご請求について</h5>
            <div class="ml-2">
              <div>
                <p>
                  【車両輸送のみ】ご依頼のお客様は、原則「WEB明細サービス」若しくは「FAX対応」のどちらかになります。
                </p>
                <div class="ml-3 ml-md-4">
                  <p>
                    ※WEB明細登録のお申し込みがない場合は、請求情報のFAX番号宛に「FAX対応」させて頂きます。
                  </p>
                  <p>
                    ※請求書原本の郵送をご希望される場合は、お手数ですが担当部門までご連絡お願い致します。
                  </p>
                </div>
              </div>
              <div class="mt-3">
                <p>
                  【登録輸送】ご依頼のお客様は、領収書の原本と一緒に郵送となります。
                </p>
                <div class="ml-3 ml-md-4">
                  <p>
                    ※月初5日営業日後の発送となりますので、到着まで1週間程かかる可能性もございます。
                  </p>
                  <p>※WEB明細サービスのご利用はできません。</p>
                </div>
              </div>
            </div>
            <h5 class="bold mt-3 pc-fs-20 ml-2">お支払い方法について</h5>
            <div class="ml-2">
              <p>
                お支払いにつきましては、依頼内容により基本下記の通りとなります。期日までにお振込お願い致します。
              </p>
              <p>また、口座振替等ご要望の場合は、お問い合わせ下さい。</p>
              <p>
                ① 車両輸送&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;・・・&emsp;
                月末締め翌15日払い
              </p>
              <p>② 登録(名義変更)輸送&emsp; ・・・&emsp; 月末締め翌末日払い</p>
            </div>
          </div>
        </section>

        <div class="text-center mt-1 mr-3 mr-md-0">
          <md-button
            type="submit"
            class="btn-lg btn-success base-btn col-md-3 col-lg-2 md-raised"
          >
            申込
          </md-button>
        </div>
      </validation-observer>
    </form>

    <md-snackbar
      :class="snackbar.class"
      md-position="center"
      :md-active.sync="snackbar.isShow"
      md-persistent
    >
      <span>{{ snackbar.text }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import Mixin from '@/components/mixin/Mixin'
import CompanyBaseInfo from '@/components/apply/CompanyBaseInfo'
import Seikyu from '@/components/apply/Seikyu'
import Bank from '@/components/apply/Bank'
import vue2Dropzone from 'vue2-dropzone'
import Constant from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'

let _this
export default {
  name: 'Used',

  mixins: [validationMixin, Mixin],

  components: {
    vueDropzone: vue2Dropzone,
    CompanyBaseInfo,
    Seikyu,
    Bank,
  },

  data: () => ({
    /** オブザーバー */
    observer: null,

    /** 基本情報入力データ取得フラグ */
    isCompanyInfoGetData: false,

    /** 銀行情報入力データ取得フラグ */
    isGinkoGetData: false,

    /** 請求先入力データ取得フラグ */
    isSeikyuGetData: false,

    /** 定休日リスト */
    teikyuList: ['月', '火', '水', '木', '金', '土', '日', '祝'],

    /** 営業時間リスト */
    eigyoJikanList: [
      { text: '未選択', value: null },
      '00:00',
      '00:30',
      '01:00',
      '01:30',
      '02:00',
      '02:30',
      '03:00',
      '03:30',
      '04:00',
      '04:30',
      '05:00',
      '05:30',
      '06:00',
      '06:30',
      '07:00',
      '07:30',
      '08:00',
      '08:30',
      '09:00',
      '09:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00',
      '15:30',
      '16:00',
      '16:30',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
      '21:30',
      '22:00',
      '22:30',
      '23:00',
    ],

    /** 台数 */
    daisuList: [
      { text: '未選択', value: null },
      '1-10',
      '11-20',
      '21-100',
      '101-',
    ],

    /** スナックバー */
    snackbar: {
      isShow: false,
      class: 'bg-danger',
      text: null,
    },

    /** 同意1 */
    consent1: false,

    /** 同意2 */
    consent2: false,

    /** 入力データ */
    form: {
      LEASE_KAISYA_KBN: 0,
      TORIHIKI_SAKI_MEI: null,
      TORIHIKI_SAKI_MEI_KANA: null,
      DAIHYO_YAKUSYOKU_MEI: null,
      DAIHYO_MEI: null,
      TORIHIKI_YUBIN1: null,
      TORIHIKI_YUBIN2: null,
      TORIHIKI_TODO_MEI: null,
      TORIHIKI_TODO_CD: null,
      TORIHIKI_SHIKU_MEI: null,
      TORIHIKI_BANCHI: null,
      TORIHIKI_SHIKU_CD: '',
      TORIHIKI_SAKI_TEL: null,
      TORIHIKI_SAKI_FAX: null,
      TANTO_MEI_SEI: null,
      TANTO_MEI: null,
      TANTO_MAIL_ADDR: null,
      TANTO_TEL: null,
      TANTO_KAKUNIN_FILE: [],
      TEIKYU_BI: [],
      EIGYO_JIKAN: null,
      EIGYO_JIKAN_START: null,
      EIGYO_JIKAN_END: null,
      SETURITU_NENGETU: null,
      SHIHON_KIN: null,
      GEKKAN_TORIATUKAI_DAISU: null,
      GEKKAN_YUSO_IRAI_DAISU: null,
      GEKKAN_TOROKU_YUSO_DAISU: null,
      RIYO_YUSO_KAISYA_MEI: null,
      GINKO: [],
      SEIKYU_SAKI_KBN: false,
      SKS_KAISYA: null,
      SKS_KAISYA_KANA: null,
      SKS_YUBIN1: null,
      SKS_YUBIN2: null,
      SKS_TODO_CD: null,
      SKS_TODO_MEI: null,
      SKS_SHIKU_CD: '',
      SKS_SHIKU_MEI: null,
      SKS_BANCHI: null,
      SKS_TEL: null,
      SKS_FAX: null,
      SKS_TANTO_MEI_SEI: null,
      SKS_TANTO_MEI: null,
      SKS_TANTO_MAIL_ADDR: null,
    },

    // ファイルアップロード関連
    uploadcount: 0,
    uploadedcount: 0,
    dropzoneOptions: {
      url: `${process.env.API.DOMAIN}${Constant.API_URL.IMAGES}`,
      thumbnailWidth: 150,
      maxFilesize: 5, // 5MB
      headers: {},
      addRemoveLinks: true,
      dictCancelUpload: 'キャンセル',
      dictRemoveFile: 'キャンセル',
      // uploadMultiple: true,
      error: function (file) {
        this.removeFile(file)
        _this.spinerOff()
        _this.$v.form.TANTO_KAKUNIN_FILE.$touch()
        _this.uploadcount--
        _this._alert('5MB以下のファイルをご利用ください', false)
      },
      dictDefaultMessage:
        "<i class='fa fa-cloud-upload'></i>ファイルを選択してください",
    },
  }),

  /** バリデーションルール */
  validations() {
    let valid = {
      consent1: {
        sameAs: sameAs(() => true),
      },
      consent2: {
        sameAs: sameAs(() => true),
      },
      form: {
        TANTO_KAKUNIN_FILE: {
          required,
        },
      },
    }
    return valid
  },

  created() {
    _this = this
  },

  mounted() {
    this.observer = this.$refs.observer
  },

  methods: {
    /** データを登録する */
    async save() {
      if (this.uploadcount !== this.uploadedcount) {
        this._alert('ファイルのアップロードが完了していません。')
        return
      }

      this.$v.$touch()
      const validResult = await this.observer.validate()

      if (!validResult || this.$v.$invalid) {
        this.spinerOff()
        return this._alert('入力項目にエラーがあります。')
      }

      this.spinerOn()
      await this.getAllData()

      // データ登録API
      this.$store
        .dispatch('tmpTorihiki/post', this.makeSaveData())
        .then((res) => {
          this.$router.push({ name: 'ApplyComplete' })
        })
        .catch((err) => {
          this.consent1 = false
          this.consent2 = false
          this.snackbar.text = 'エラーが発生しました code: 001'
          this.snackbar.isShow = true
        })
        .finally(() => this.spinerOff())
    },

    /** 保存用データに整形する */
    makeSaveData() {
      let d = _.cloneDeep(this.form)
      d.EIGYO_JIKAN = `${d.EIGYO_JIKAN_START}~${d.EIGYO_JIKAN_END}`
      d.TEIKYU_BI = this.sortStrWeek(d.TEIKYU_BI.join(','))
      return d
    },

    // 子コンポーネントの入力データを取得する
    async getAllData() {
      this.isCompanyInfoGetData = true
      this.isSeikyuGetData = true
      this.isGinkoGetData = true
      await this.sleep(50)
    },

    /** データをマージする */
    mergeForm(val) {
      if (val) {
        let data = {}
        for (const name in val) {
          if (this.form.hasOwnProperty(name)) data[name] = val[name]
        }
        _.merge(this.form, data)
      }
    },

    /**
     * アップロードファイルのUUIDとマイクロタイムスタンプのリクエストヘッダ付与。
     * ＠TODO タイミングによりUUIDが他ファイルのUUIDで上書きされないか心配(要検証)
     * @param  {object} file ファイルオブジェクト
     */
    vfileSend(file) {
      this.spinerOn()
      this.dropzoneOptions.headers.UUID = file.upload.uuid
      this.dropzoneOptions.headers.SENDUNIXTIME = file.lastModified
    },
    /**
     * アップロード完了時にURLを格納する
     * @param  {object} file ファイルオブジェクト
     */
    vfilesent(file) {
      this.spinerOff()
      this.scroll('clear')
      this.$data.form.TANTO_KAKUNIN_FILE.push(file.xhr.response)
      this.uploadedcount++
    },
    Survey(file) {
      const conds = [
        'image/jpeg',
        'image/png',
        'application/pdf',
        'image/gif',
        'image/bmp',
      ]
      if (!conds.includes(file.type)) {
        this._alert(
          '.jpg .bmp .gif .pdf .pngのファイルをアップしてください',
          false
        )
        this.$refs.myVueDropzone.removeFile(file)
      } else {
        this.uploadcount++
      }
    },
    removeFile(file) {
      let files = []
      for (const index in this.form.TANTO_KAKUNIN_FILE) {
        const fileName = this.form.TANTO_KAKUNIN_FILE[index]
        if (file.xhr.response !== fileName) {
          files.push(fileName)
        }
      }
      this.form.TANTO_KAKUNIN_FILE = files
      this.uploadedcount--
      this.uploadcount--
    },

    /** baseinfoの入力データをマージする */
    onSetBaseInfoData(val) {
      this.mergeForm(val)
      this.isCompanyInfoGetData = false
    },

    /** 銀行情報の入力データをマージする */
    onSetGinko(val) {
      this.form.GINKO = val
      this.isGinkoGetData = false
    },

    /** 請求先の入力データをマージする */
    onSetSeikyu(val) {
      this.mergeForm(val)
      this.isSeikyuGetData = false
    },
  },

  computed: {
    /** 設立年月 */
    seturituNengetu: {
      get() {
        return this.form.SETURITU_NENGETU
          ? new Date(this.form.SETURITU_NENGETU)
          : null
      },
      set(newVal) {
        this.form.SETURITU_NENGETU = this.dateObjToStr(newVal)
      },
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.md-raised
  background: $baseGreenColor !important
.section-wrapper
  background: $baseGrayColor
  padding: 1%
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
section#apply-consent
  margin: 20px auto
  background: $baseGrayColor
  border: 5px solid $baseBlueColor
  .check-box-wrapper
    margin-left: 20%
</style>



// WEBPACK FOOTER //
// src/components/apply/Used.vue